import { CarrierDto, KnownProjectFeature, ProjectDto } from '@groundfloor-platform/mgmt-service-g-sdk';

/** Where carrier organisations are filed. The flag is the contract, never the project id. */
export function isCarrierManagementProject(project?: Pick<ProjectDto, 'enabledFeatures'>): boolean {
  return project?.enabledFeatures?.includes(KnownProjectFeature.CarrierManagement) ?? false;
}

/**
 * The project the API authorises a carrier's actions against: the one its container is filed under
 * (a pool's network, a company's carrier project). Permissions inherit downwards, so checking the
 * viewer's project instead could offer an action the API then refuses. Falls back to that project
 * where the carrier names no container project.
 */
export function carrierAuthorisingProjectID(carrier: Pick<CarrierDto, 'container'>, viewerProjectID: string): string {
  return carrier.container?.project?.id || viewerProjectID;
}
